import React from "react";
import PropTypes from "prop-types";

import MuiSwitch from "@mui/material/Switch";
import MuiCheckbox from "@mui/material/Checkbox";
import MuiRadio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { INDETERMINATE_VALUE } from "lib/constants";

export const Switch = ({ labelPlacement, labelClassName, ...props }) => (
    <FormControlLabel
        className={labelClassName}
        labelPlacement={labelPlacement}
        label={props.children}
        control={<MuiSwitch {...props} />}
    />
);

Switch.propTypes = {
    labelPlacement: PropTypes.oneOf(["end", "start", "top", "bottom"]),
    labelClassName: PropTypes.string,
};

Switch.defaultProps = {
    labelPlacement: "end",
    labelClassName: "",
};

export const Checkbox = ({ labelPlacement, labelClassName, checked, ...props }) => (
    <FormControlLabel
        className={labelClassName}
        labelPlacement={labelPlacement}
        label={props.children}
        control={
            <MuiCheckbox
                indeterminate={checked === INDETERMINATE_VALUE}
                checked={checked !== INDETERMINATE_VALUE && checked}
                {...props}
            />
        }
    />
);

Checkbox.propTypes = {
    labelPlacement: PropTypes.oneOf(["end", "start", "top", "bottom"]),
    checked: PropTypes.oneOf([true, false, INDETERMINATE_VALUE]),
    labelClassName: PropTypes.string,
};

Checkbox.defaultProps = {
    labelPlacement: "end",
    checked: false,
    labelClassName: "",
};

export const Radio = ({ labelPlacement, labelClassName, ...props }) => (
    <FormControlLabel
        className={labelClassName}
        labelPlacement={labelPlacement}
        label={props.children}
        control={<MuiRadio {...props} />}
    />
);

Radio.propTypes = {
    labelPlacement: PropTypes.oneOf(["end", "start", "top", "bottom"]),
    labelClassName: PropTypes.string,
};

Radio.defaultProps = {
    labelPlacement: "end",
    labelClassName: "",
};
